import TransactionModal from "./transactionModal.js";
import { $_GET } from "../globalFunctions.js";

export default class ConvertibleLoanModal extends TransactionModal {
	constructor(companyId) {
		super("convertible-loan-modal", companyId);

		this.formFields = [
			{
				name: "id",
				varType: "int",
			},
			{
				name: "stakeholder",
				varType: "int",
				required: true,
				trigger: "change",
			},
			{
				name: "beneficiary",
				varType: "int",
			},
			{
				name: "amount",
				varType: "float",
				required: true,
			},
			{
				name: "date",
				varType: "string",
				required: true,
			},
			{
				name: "maturity_date",
				varType: "string",
			},
			{
				name: "valuation_floor",
				varType: "int",
			},
			{
				name: "valuation_cap",
				varType: "int",
			},
			{
				name: "discount",
				varType: "float",
			},
			{
				name: "interest_start_date",
				varType: "string",
			},
			{
				name: "interest_percent",
				varType: "float",
			},
			{
				name: "interest_days",
				varType: "radio",
			},
			{
				name: "interest_payback",
				varType: "radio",
			},
			{
				name: "documents",
				varType: "simple-array",
				type: "int",
			},
			{
				name: "notes",
			},
		];
		this.setupListeners();

		Promise.all([this.documentsPromise, this.setupStakeholders()]).then(() => {
			this.whenReady();
		});
	}

	whenReady() {
		if (this.prefillData === null) {
			this.setupForm();
		}
		super.whenReady();
		if (this.currentData !== null && this.currentData.readOnly) {
			document.querySelector("[data-lucide=\"lock\"]").classList.remove("d-none");
			document.querySelector("[id=\"readOnlyAlert\"]").classList.remove("d-none");
			this.$form.querySelectorAll("input, select, textarea, button").forEach(el => {
				if(el.getAttribute("data-close-button") || el.getAttribute("data-bs-toggle")) {
					return;
				}
				el.setAttribute("disabled", true);
			});
			this.enableSubmitButton(false);
		}
	}

	setupForm() {
		this.$form.querySelector("[name=\"date\"]").valueAsDate = new Date();
		this.$form.querySelector("[name=\"interest-start-date\"]").valueAsDate =
			new Date();
	}

	setupListeners() {
		// until he hasn't saved the note, sync interest start date & loan date
		const $date = this.$form.querySelector("[name=\"date\"]");
		$date.addEventListener("change", (e) => {
			if (this.getInt("id") === null) {
				this.$form.querySelector("[name=\"interest-start-date\"]").value =
					$date.value;
			}
		});
	}

	validateAndSendForm() {
		if(this.currentData !== null && this.currentData.readOnly) {
			return;
		}
		this.getFields(this.formFields)
			.then((data) => {
				data.company = this.companyId;
				data.simulation =
					typeof window.pequeData.simulation === "undefined"
						? $_GET("simulation")
						: window.pequeData.simulation;
				data.type = peque.TRANSACTION_TYPE_CONVERTIBLE_LOAN;

				if (data.valuation_cap > 0 && data.valuation_cap < data.amount) {
					return this.showErrorOnField(
						"Cap value must be larger than investment",
						this.$form.querySelector("[name=\"valuation-cap\"]"),
					);
				}

				peque
					.api("transactions", JSON.stringify(data), "post")
					.then((response) => {
						this.mutateReactTransactions();
					});
			})
			.catch((error) => {
				if (typeof error.el === "undefined") {
					console.error(error);
					return;
				}
				this.showErrorOnField(error.message, error.el);
			});
	}
}
